require('./DashboardModalTaskCollapsibleContent.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    {t} = require('services/i18nextWrapper'),
    {find, map, every, some, filter} = require('lodash/collection'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    get = require('lodash/object').get,
    {delay} = require('lodash/function'),
    {merge} = require('lodash/object'),
    NumberUtils = require('utils/NumberUtils'),
    ContentUtils = require('utils/ContentUtils'),
    OrderUtils = require('utils/OrderUtils'),
    SessionStore = require('stores/SessionStore'),
    BrewhouseStore = require('stores/BrewhouseStore'),
    DateUtils = require('utils/DateUtils'),
    {TIME_WAIT_MODAL_REFRESH_EXPAND} = require('constants/AppConstants'),
    InventoryStore = require('stores/InventoryStore'),
    DashboardModalTaskCollapsibleItemAmountSmall = require('./DashboardModalTaskCollapsibleItemAmountSmall'),
    {FontIcon, TextField, Toggle} = require('material-ui');

const DashboardModalTaskCollapsibleItemAmount = React.createClass({displayName: "DashboardModalTaskCollapsibleItemAmount",

    propTypes: {
        task: PropTypes.object,
        product: PropTypes.object,
        uniqueId: PropTypes.string,
        amount: PropTypes.number,
        locations: PropTypes.array,
        allowToConfirmProduct: PropTypes.boolean,
        shouldBeDisabled: PropTypes.boolean,
        onChangeAmountInLocation: PropTypes.func.isRequired,
        onChangeProducts: PropTypes.func.isRequired,
        onChangeVolumeItem: PropTypes.func.isRequired,
        renderItemAgain: PropTypes.func.isRequired,
        onChangeAmountItem: PropTypes.func.isRequired,
        onConfirmProduct: PropTypes.func.isRequired
    },

    getInitialState() {
        return {
            isCollapsed: true,
            isDisabled: true,
            isFocusAmountField: false,
            isFocusVolumeField: false,
            amount: '',
            isCalculatingInventory: SessionStore.isCalculatingInventory(),
            currencyInfo: NumberUtils.getCurrentCurrency(),
            vendorItems: DashboardServiceCache.getVendorItems()
        };
    },

    onToggleExpand() {
        this.setState(prevState => {
            return {
                isCollapsed: !prevState.isCollapsed
            };
        });
    },

    componentDidUpdate() {
        const {product} = this.props;
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }

        delay(() => {
            const amount = (get(product, 'customAmount') || get(product, 'amount') || '');
            const haveAmountDefined = !!amount;
            if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
                return;
            }
            if (this.refs.inputValue) {
                this.refs.inputValue.setValue(haveAmountDefined ? (NumberUtils.formatDecimal(get(product, 'customAmount')  || get(product, 'amount') || '')) : '');
            }
            if (this.refs.inputVolumeValue) {
                this.refs.inputVolumeValue.setValue(haveAmountDefined ? NumberUtils.formatDecimal(get(product, 'customVolume')  || get(product, 'volume') || '') : '');
            }

            if (this.state.isDisabled && haveAmountDefined && NumberUtils.isGreater(amount, 0)) {
                this.forceUpdate(); // need to sync the amount display of amount of the component.
                this.props.renderItemAgain();
            }
        }, TIME_WAIT_MODAL_REFRESH_EXPAND); // these need to be longer than time expend on product scope hydratation from DashboardModal[B|S][New|Change] _onToggleExpand function timeout.
    },

    componentWillReceiveProps(nextProps) {
        const amount = get(nextProps, 'product.amount', 0);
        const endDate = get(nextProps, 'product.endDate') || get(nextProps, 'task.date');
        const isDisabled = NumberUtils.isLessOrEquals(amount, 0);
        this.setState({
            amount,
            isDisabled
        }, () => {
            if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
                return;
            }
            if (endDate && this.refs.toDate) {
                this.refs.toDate.setTime(DateUtils.toDateFromFullDate(endDate));
            }
        });
    },

    _onChangeAmountSmall(productItem, evt) {
        const {onChangeProducts, product, uniqueId, task} = this.props;
        const newAmount = get(evt, 'target.value');
        const itemId = get(productItem, 'item.id');

        // update the amount of the product item
        let productUpdated = InventoryStore.changeAmountOfProductItem(product, itemId, newAmount);

        // each time we need to update product amount, we reset flag
        // just in case that we change amount from one particular location
        productUpdated = InventoryStore.turnOffWhereInventoryWasTakenNonChanged(productUpdated);

        const avoidMultiplyItemByAmountProduct = true;
    
        // We need to clear all where inventory was taken because we are changing
        // the parent amount, to need to re-calculate inventory again.
        productUpdated = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdated);
        // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
        productUpdated.isNeededCalculateInventory = undefined;
        
        onChangeProducts(productUpdated, productUpdated.amount, uniqueId, task, avoidMultiplyItemByAmountProduct);
    },


    _onChangeAmountInLocation(productItemUpdated) {
        const {onChangeProducts, product, uniqueId, task} = this.props;

        // update product items which are location amount updated
        const productUpdated = InventoryStore.updateProductItemFromProduct(product, productItemUpdated);

        const avoidMultiplyItemByAmountProduct = true;
        onChangeProducts(productUpdated, productUpdated.amount, uniqueId, task, avoidMultiplyItemByAmountProduct);
    },

    _onChangeAmount() {
        const {onChangeProducts, product, uniqueId, task} = this.props;

        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }

        if (this.refs.inputValue) {
            const newAmount = NumberUtils.standardiseDecimalFormatNumber(this.refs.inputValue.getValue());
            const amountOld = get(find(get(task, 'products'), p => p.id === product.id), 'amount');
            const isSameAmount = NumberUtils.isEqual(newAmount, amountOld);

            if (isSameAmount) {
                this._onBlurFocusableElement();
                return;
            }

            const isDisabled = newAmount === 0 || newAmount === undefined;
            const haveAmountDefined = NumberUtils.isGreater(newAmount, 0);
            this._onBlurFocusableElement();
            this.setState(prevState => {
                return {
                    isCollapsed: haveAmountDefined ? prevState.isCollapsed : true,
                    isDisabled: haveAmountDefined ? isDisabled : true
                };
            }, () => {
                if (onChangeProducts !== undefined) {
                    // each time we need to update product amount, we reset flag
                    // just in case that we change amount from one particular location
                    let productUpdated = InventoryStore.turnOffWhereInventoryWasTakenNonChanged(product);
                    const productUpdatedByAmount = InventoryStore.onChangeProductByAmount(productUpdated, newAmount);
    
                    // We need to clear all where inventory was taken because we are changing
                    // the parent amount, to need to re-calculate inventory again.
                    productUpdated = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdated);
                    // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
                    productUpdated.isNeededCalculateInventory = undefined;
    
                    onChangeProducts(productUpdatedByAmount, newAmount, uniqueId, task);
                }
            });
        }
    },

    _onChangeVolume() {
        const {onChangeVolumeItem, product, uniqueId, task} = this.props;
        if (this.refs.inputVolumeValue) {
            const newPorcent = NumberUtils.standardiseDecimalFormatNumber(this.refs.inputVolumeValue.getValue());
            const oldPorcent = get(find(get(task, 'products'), p => p.id === product.id), 'volume');
            const isSamePorcent = NumberUtils.isEqual(newPorcent, oldPorcent);

            if (isSamePorcent) {
                this._onBlurFocusableElement();
                return;
            }

            const isDisabled = newPorcent === 0 || newPorcent === undefined;
            const haveAmountDefined = NumberUtils.isGreater(newPorcent, 0);

            this._onBlurFocusableElement();
            this.setState(prevState => {
                return {
                    isCollapsed: haveAmountDefined ? prevState.isCollapsed : true,
                    isDisabled: haveAmountDefined ? isDisabled : true
                };
            }, () => {
                if (onChangeVolumeItem !== undefined) {
                    let productUpdatedByVolume = InventoryStore.onChangeProductByVolume(product, newPorcent);
                    // We need to clear all where inventory was taken because we are changing
                    // the parent amount, to need to re-calculate inventory again.
                    productUpdatedByVolume = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdatedByVolume);
                    // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
                    productUpdatedByVolume.isNeededCalculateInventory = undefined;
                    onChangeVolumeItem(productUpdatedByVolume, newPorcent, uniqueId, task);
                }
            });
        }
    },

    _getIconToggleEl() {
        const {isCollapsed, isDisabled} = this.state;
        const couldExpand = !isDisabled && !this.state.isCollapsed;
        const classNameIconPlus = couldExpand ? 'material-icons modal-order-task-list-item__receipe is-body is-expanded' : 'material-icons modal-order-task-list-item__receipe is-body';

        return (
          React.createElement("span", {className: classNameIconPlus}, 
                    
                        isCollapsed || isDisabled ? (
                          React.createElement("i", {style: {
                              color: isDisabled ? '#d5d5d5' : 'initial',
                              cursor: isDisabled ? 'default' : 'pointer'
                          }, 
                             "data-test-id": "icon-button-detail-product", 
                             title: t('dashboard_modal_task_customize_items'), 
                             className: "material-icons md-16", 
                             onClick: this.onToggleExpand}, "add_circle_outline")
                        ) : (
                          React.createElement("i", {title: t('dashboard_modal_task_customize_items'), 
                             "data-test-id": "icon-button-detail-product", 
                             className: "material-icons md-16", 
                             onClick: this.onToggleExpand}, "remove_circle_outline")
                        )
                    
                    )
        );
    },

    _getProductItemsEl(productUpdated, locations) {
        const {isCollapsed, isDisabled} = this.state;
        const {task} = this.props;
        const isConfirmed = get(productUpdated, 'isConfirmed');
        const productItems = ContentUtils.filterEnable(get(productUpdated, 'items'));
        // filter product items addition, because is not need to show it
        const productItemsFiltered = filter(productItems, productItem => get(productItem, 'addition') !== true);
        const productItemsSorted = ContentUtils.sortList(productItemsFiltered, 'item.description');
  
        return isCollapsed || isDisabled ? null : (
            React.createElement("ul", null, 
                
                    map(productItemsSorted, productItem =>
                        React.createElement(DashboardModalTaskCollapsibleItemAmountSmall, {
                            amount: this._getItemAmount(productItem), 
                            onChangeAmountInLocation: this._onChangeAmountInLocation, 
                            locations: locations, 
                            isConfirmed: isConfirmed, 
                            task: task, 
                            productItem: productItem, 
                            product: productUpdated, 
                            onChangeAmount: this._onChangeAmountSmall}
                        )
                    )
                
            )
        );
    },

    _getItemAmount(productItem) {
        // get first manual amount, then estimated amount, and finally original amount of item.
        // Here should be reduce all where inventory was taken from the productItem
        const adjustAmountValue = +get(productItem, 'adjustAmount');
        const adjustAmountValueSafe = ContentUtils.isNull(adjustAmountValue) || adjustAmountValue === 0 || adjustAmountValue === 'NaN' ? undefined : adjustAmountValue;

        return adjustAmountValueSafe || get(productItem, 'manualAmount') || get(productItem, 'estimateAmount') || get(productItem, 'amount', 0);
    },

    _getIconInventoryIndicator(product) {
        const productAmount = get(product, 'amount') || 0;
        const haveAmount = NumberUtils.isGreater(productAmount, 0);
        const hasConfirm = get(product, 'isConfirmed');
        const hasDiscounted = get(product, 'isDiscounted');

        if (!haveAmount || hasConfirm || (!hasConfirm && hasDiscounted)) {
            // enter here means we don't need the icon of
            // inventory status
            return;
        }

        //const productUpdated = _hydrateItemsFromProduct(product);
        let productItems = get(product, 'items');

        // remove product item addition
        productItems = filter(productItems, productItem => get(productItem, 'addition') !== true && NumberUtils.isGreater(get(productItem, 'amount'), '0'));

        // check if all the item have enough item in existing inventory
        const isEnoughInventory = every(productItems, productItem => productItem.isEnoughInventory);

        // check if at least have some items, to indicate that some items was discounted
        const existItemInStock = some(productItems, productItem => productItem.existItemInStock);

        // in case that non exist enough item in inventory check if at least is
        // already purchased (Check for more information {@link InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation)}
        const isPurchased = InventoryStore.isSomeItemAlreadyPurchased(productItems);

        // indicate that some purchase not was enough
        const missingPurchase = !isEnoughInventory && some(productItems, productItem => !productItem.isEnoughInventory && !productItem.isPurchasedAmountEnough);

        if (!product || !product.amount) {
            // enter here means don't have product yet
            return null;
        }

        const topPosition = 25;
        const iconsEl = [];
        let horizontalIndex = -30;
        let initialOffeset = 4;

        if (existItemInStock) {
            horizontalIndex += 30 + initialOffeset;
            initialOffeset = 0;
            iconsEl.push({
                type: 'STOCK',
                el:(
                    React.createElement(FontIcon, {
                        "data-inventory-info": "enough_inventory", 
                        style: {
                            fontSize: '12px;',
                            top: topPosition + 'px',
                            padding: '3px',
                            borderRadius: '50%',
                            border: 'solid 2px black',
                            position: 'absolute',
                            backgroundColor: '#0f9d58',
                            right: `-${horizontalIndex}px`
                        }, 
                        className: "material-icons"
                    }, "home")
                )
            });
        }

        if (isPurchased) {
            horizontalIndex += 30 + initialOffeset;
            initialOffeset = 0;
            iconsEl.push({
                type: 'PURCHASE',
                el:(
                React.createElement(FontIcon, {
                    "data-inventory-info": "need_purchase", 
                    style: {
                        fontSize: '12px;',
                        top: topPosition + 'px',
                        padding: '3px',
                        borderRadius: '50%',
                        border: 'solid 2px black',
                        position: 'absolute',
                        backgroundColor: '#fcca2e',
                        right: `-${horizontalIndex}px`
                    }, 
                    className: "material-icons"
                }, "shopping_cart"))
            }
            );
        }

        if (missingPurchase || (!isEnoughInventory && !isPurchased)) {
            horizontalIndex += 30 + initialOffeset;
            initialOffeset = 0;
            iconsEl.push({
                    type: 'MISSING',
                    el: (
                        React.createElement(FontIcon, {
                            "data-inventory-info": "not_inventory", 
                            style: {
                                fontSize: '12px;',
                                top: topPosition + 'px',
                                padding: '3px',
                                borderRadius: '50%',
                                border: 'solid 2px black',
                                position: 'absolute',
                                backgroundColor: '#db4437',
                                right: `-${horizontalIndex}px`
                            }, 
                            className: "material-icons"
                        }, "shopping_cart"))
                }
            );
        }

        return iconsEl;
    },

    _getToggleConfirmProduct(product, uniqueId, onConfirmProduct, task) {
        const {isFocusAmountValue, isFocusVolumeValue, isCalculatingInventory} = this.state;
        const shouldHideToggle = isFocusAmountValue || isFocusVolumeValue;
        const isDisconfirmingPublishedProduct = !product.isConfirmed && product.isDiscounted;
        const haveProductAmount = NumberUtils.isGreater(get(product, 'amount'), '0');
        const itemsSubtraction = filter(get(product, 'items'), item => !item.addition);
        const haveSomeItemMissing = InventoryStore.haveMissingItemWhereLocationWasSubtract(itemsSubtraction);

        const toggleEl = (shouldHideToggle || !this.isMounted()) ? null : isCalculatingInventory ? (
            React.createElement("div", null, 
                React.createElement("label", null, 
                    t('dashboard_modal_task_confirmed')
                ), 
                React.createElement(Toggle, {
                    name: "isConfirmProduct", 
                    defaultToggled: product.isConfirmed, 
                    defaultValue: product.isConfirmed, 
                    onToggle: onConfirmProduct.bind(this, product, uniqueId, task)}
                )
            )
        ) : null;

        const restrictedLabelEl = isDisconfirmingPublishedProduct ? (
            React.createElement("label", null, t('dashboard_modal_task_items_return_inventory_label'))
        ) : null;

        let className = 'dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-product-confirm col-xs-2';
        if (restrictedLabelEl) {
            className += ' is-restricted';
        }

        return haveProductAmount && !haveSomeItemMissing ? (
            React.createElement("div", {
                className: className}, 
                restrictedLabelEl ? restrictedLabelEl : toggleEl
            )
        ) : null;
    },

    _onFocusElement(focusField) {
           switch(focusField) {
               case 'AMOUNT':
                   this.setState({
                       isFocusAmountValue: true,
                       isFocusVolumeValue: false
                   });
                   break;
               case 'VOLUME':
                   this.setState({
                       isFocusAmountValue: false,
                       isFocusVolumeValue: true
                   });
                   break;
           }
    },

    _onBlurFocusableElement() {
        this.setState({
            isFocusAmountValue: false,
            isFocusVolumeValue: false
        });
    },

    _getRowEditable(product, uniqueId, onConfirmProduct, task, isCalculatingInventory) {
        const styleInputs = {
            marginTop: '-10px',
            height: '40px',
            lineHeight: '25px',
            width: 'initial'
        };

        const {allowToConfirmProduct, shouldBeDisabled} = this.props;
        const isDisconfirmingPublishedProduct = !product.isConfirmed && product.isDiscounted;
        const productItems = get(product, 'items');
        const isTaskAfterToDay = DateUtils.isAfterToDay(product.taskDate); // not included today
        const productItemsSubtraction = filter(productItems, productItem => !productItem.addition) || [];
        const productItemsAddition = filter(productItems, productItem => productItem.addition) || [];
        const thereIsNotItemSubstractionAndAddition = productItemsSubtraction && productItemsSubtraction.length === 0 &&
          productItemsAddition && productItemsAddition.length === 0;
        const thereIsNotItemSubstraction = productItemsSubtraction && productItemsSubtraction.length === 0;
        const iconInventoryIndicator = this._getIconInventoryIndicator(product);
        const someItemNeedPurchaseOrIsMissing = some(iconInventoryIndicator, info => get(info, 'type') === 'PURCHASE' || get(info, 'type') === 'MISSING');
        const items = get(product, 'items', []) || [];
        const productCost = BrewhouseStore.calculateCostByItems(items, this.state.vendorItems);
        console.log(productCost);

        // this flag indicate if possible to confirm manually
        // the discount of the items of the product against to inventory
        const showConfirmProduct = (someItemNeedPurchaseOrIsMissing ? false : !DateUtils.isAfterToDayFullDate(product.endDate || task.date));
        const iconToggleEl = thereIsNotItemSubstraction ? null : this._getIconToggleEl();
        const isProductConfirmed = get(product, 'isConfirmed');
        const toggleConfirmProductEl = (isTaskAfterToDay && isCalculatingInventory) || thereIsNotItemSubstractionAndAddition
          ? null
          : !allowToConfirmProduct
          ? React.createElement("label", {className: "dashboard-modal-task-collapsible-content__is-disabled-confirmed-product"}, t('dashboard_modal_task_confirm_prior'), React.createElement("br", null), t('dashboard_modal_task_icon_first'))
          : isDisconfirmingPublishedProduct || showConfirmProduct
          ? this._getToggleConfirmProduct(product, uniqueId, onConfirmProduct, task)
          : null;
    
        const inputsShouldBeDisable = shouldBeDisabled
          ? true
          : isDisconfirmingPublishedProduct || isProductConfirmed
          ? true
          : false;

        return (
            React.createElement("li", {key: `content__list-${uniqueId}`, className: "dashboard-modal-task-collapsible-content dashboard-modal-task-collapsible-content__list-header row", 
                style: {
                    listStyle: 'none'
                }}, 
                React.createElement("div", {
                    className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-product-name col-xs-2"}, 
                    React.createElement("label", null, 
                        t('dashboard_modal_task_products_name')
                    ), 
                    React.createElement("div", null, `${get(product, 'name')} `)
                ), 
                React.createElement("div", {
                    className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-amount col-xs-2"}, 
                    React.createElement("label", null, `${t('dashboard_modal_task_products_amount')} `, React.createElement("small", null, t('dashboard_modal_task_products_unit'))), 
                    React.createElement(TextField, {
                        key: `text-amount-${uniqueId}`, 
                        onBlur: this._onChangeAmount.bind(this), 
                        onFocus: this._onFocusElement.bind(this, 'AMOUNT'), 
                        ref: "inputValue", 
                        hintText: t('dashboard_modal_task_products_amount'), 
                        style: styleInputs, 
                        defaultValue: get(product, 'customAmount') || get(product, 'amount') || '', 
                        disabled: inputsShouldBeDisable
                    }
                    )
                ), 
                React.createElement("div", {
                    className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-volume col-xs-2"}, 

                    React.createElement("label", null, `${t('dashboard_modal_task_products_volume')} `, React.createElement("small", null, "(", DashboardServiceCache.getCurrentUnitTank(), ")")), 
                    React.createElement(TextField, {
                        key: `text-amount-${uniqueId}`, 
                        onBlur: this._onChangeVolume.bind(this), 
                        onFocus: this._onFocusElement.bind(this, 'VOLUME'), 
                        ref: "inputVolumeValue", 
                        hintText: t('dashboard_modal_task_products_volume'), 
                        style: styleInputs, 
                        disabled: inputsShouldBeDisable
                    }
                    )
                ), 
    
                React.createElement("div", {
                  className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-product-cost col-xs-2"}, 
                    React.createElement(TextField, {
                      floatingLabelText: t('dashboard_modal_footer_product_cost'), 
                      value: `${get(this.state.currencyInfo, 'symbol')} ${productCost}`, 
                      disabled: true, 
                      style: styleInputs, 
                      key: 'productCost-' + uniqueId}
                    )
                ), 
                React.createElement("div", {className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-end-hour col-xs-2"}, 
                    toggleConfirmProductEl
                ), 
                React.createElement("div", {
                    className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-more-detail col-xs-1"}, 
                    React.createElement("span", null, map(iconInventoryIndicator, info => get(info, 'el')) || null), 
                    iconToggleEl
                )
            )
        );
    },

    _getRowNonEditable(productUpdated, uniqueId) {
        const messageError =  `${get(productUpdated, 'name')} ${t('dashboard_modal_task_inline_error_without_items_yet')}`;
        return (
            React.createElement("li", {key: `content__list-${uniqueId}`, className: "dashboard-modal-task-collapsible-content  dashboard-modal-task-collapsible-content__list-header row", 
                style: {
                    listStyle: 'none'
                }}, 
                React.createElement("label", {
                    className: "dashboard-modal-task-collapsible-content__label dashboard-modal-task-collapsible-content__label-product-name text-left col-xs-offset-1 col-xs-2"}, 
                    `${get(productUpdated, 'item.description') || ''} ${get(productUpdated, 'item.unit') || ''}`
                ), 
                React.createElement("div", {
                    className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-amount col-xs-6"}, 
                    React.createElement(FontIcon, {
                        style: {
                            position: 'absolute',
                            right: '165px',
                            top: '3px',
                            fontSize: '18px',
                            color: '#fcca2e'
                        }, 
                        className: "material-icons"
                    }, "warning"), " ", messageError
                )
            )
        );
    },

    render() {
        const {product, uniqueId, locations, onConfirmProduct, task} = this.props;
        const {isCalculatingInventory} = this.state;
        const sortedLocations = ContentUtils.sortListDesc(locations, 'id');
        const productUpdated = _hydrateProduct(product);
        const productUpdatedWithItems = _hydrateItemsFromProduct(productUpdated);

        const productItems = get(productUpdatedWithItems, 'items');
        const haveProductItems = get(productItems, 'length', 0) > 0;
        const inputAmount = haveProductItems ? this._getRowEditable(productUpdated, uniqueId, onConfirmProduct, task, isCalculatingInventory)
            : this._getRowNonEditable(productUpdated, uniqueId);

        const productItemsEl = this._getProductItemsEl(productUpdated, sortedLocations);

        return (
            React.createElement("div", {key: `content-${uniqueId}`, className: "dashboard-modal-item-amount"}, 
                React.createElement("div", {className: "dashboard-modal-item-amount__header"}, 
                    inputAmount
                ), 
                React.createElement("div", {className: "dashboard-modal-item-amount__list"}, 
                    productItemsEl
                )
            )
        );
    }
});

function _hydrateProduct(product, fullProducts = DashboardServiceCache.getProducts()) {
    const productTarget = find(fullProducts, fullProduct => get(fullProduct, 'id') === get(product, 'id'));
    // complete each product task with full product info
    const productUpdated = merge(productTarget, product);

    return productUpdated;
}

function _hydrateItemsFromProduct(productUpdated) {
    const itemsDry = get(productUpdated, 'items');

    if (ContentUtils.isNotEmptyArray(itemsDry)) {
        const itemsfull = DashboardServiceCache.getItems();
        let itemsUpdated = [];
        for (const productItemDry of itemsDry) {
            const itemDry = get(productItemDry, 'item');
            const itemDryId = get(productItemDry, 'itemId') || get(itemDry, 'id');
            const itemTarget = find(itemsfull, item => get(item, 'id') === itemDryId);
            const itemUpdate = merge(itemTarget, itemDry);

            productItemDry.item = itemUpdate;
            itemsUpdated.push(productItemDry);
        }
        productUpdated.items = itemsUpdated;
    }
    return productUpdated;
}


module.exports = DashboardModalTaskCollapsibleItemAmount;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsibleItemAmount.jsx
 **/